import React from "react";
import Navigation from "../partials/Navigation";
import HorizontalNav from "../partials/Dashboard/HorizontalNav";
import {Helmet} from "react-helmet";
import CoursePage from "../partials/Courses/CoursePage";

const PartnerPortal = () => {

    return (
        <div className="main-wrapper">

            <Helmet>
				<title>Partnerportal</title>
				<meta name="description" content="" />
			</Helmet>

            <Navigation />

            <div className="page-content-wrap">
                <HorizontalNav title="Partnerportal" />

                <div className="pt-5 pb-5 pb-lg-6 pt-lg-0 page-content-inner position-relative">
                    <CoursePage courseid="25162" slug="partner-portal" />
                </div>
            </div>
        </div>
    )
}

export default PartnerPortal;